import React from "react";
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Check, GripVertical, Plus } from "lucide-react";
import { Input, Checkbox, Button } from "antd";
import { v4 as uuid } from "uuid";

export interface Item { id: string; text: string; checked: boolean }
interface Props {
  items: Item[];
  onChange: (it: Item[]) => void;
}
export default function Checklist({
  items,
  onChange,
}: {
  items: Item[];
  onChange: (i: Item[]) => void;
}) {
  const update = (idx: number, patch: Partial<Item>) =>
    onChange(items.map((it, i) => (i === idx ? { ...it, ...patch } : it)));

  return (
    <>
      {items.map((it, i) => (
        <div key={it.id} style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <input
            type="checkbox"
            checked={it.checked}
            onChange={(e) => update(i, { checked: e.target.checked })}
          />
          <Input
            value={it.text}
            onChange={(e) => update(i, { text: e.target.value })}
            bordered={false}
            style={{ flex: 1, background: "transparent" }}
          />
        </div>
      ))}
      <Button
        type="text"
        icon={<Plus size={14} />}
        onClick={() => onChange([...items, { id: uuid(), text: "", checked: false }])}
      >
        Добавить пункт
      </Button>
    </>
  );
}

function SortableRow({ item, onChange, items }: { item: Item; onChange: (it: Item[]) => void; items: Item[] }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "4px 0",
  } as const;

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <span {...listeners} style={{ cursor: "grab" }}>
        <GripVertical size={16} />
      </span>
      <Checkbox
        checked={item.checked}
        onChange={(e) =>
          onChange(
            items.map((it) => (it.id === item.id ? { ...it, checked: e.target.checked } : it))
          )
        }
      />
      <Input
        value={item.text}
        onChange={(e) =>
          onChange(items.map((it) => (it.id === item.id ? { ...it, text: e.target.value } : it)))
        }
        bordered={false}
        style={{ textDecoration: item.checked ? "line-through" : undefined }}
      />
    </div>
  );
}